module.exports = __webpack_public_path__ + "img/auto-3.0a71d0a2.png";